import { useEffect } from 'react';
import EventEmitter, { actions } from '@/utils/eventemitter';
import { useRouter } from 'next/router';

const usePopUpDeleteQuery = () => {
  const router = useRouter();
  const query = router.query;
  const showPopup = router.query?.isLoginSignupPopup as string;
  const popUp = () => {
    EventEmitter.emit(actions[showPopup]);
  };
  useEffect(() => {
    if (showPopup) {
      router.events.on('routeChangeComplete', popUp);
      const pathname = router.pathname;
      const isLoginSignupPopupValue = query?.isLoginSignupPopup as string;
      const linkAs = router?.asPath.replace(`&isLoginSignupPopup=${isLoginSignupPopupValue}`, '');
      delete query.isLoginSignupPopup;
      router.push(
        {
          pathname: pathname,
          query: { ...query }
        },
        linkAs,
        {
          shallow: false
        }
      );
    }
    return () => {
      router.events.off('routeChangeComplete', popUp);
    };
  }, [router?.isReady]);
};
export default usePopUpDeleteQuery;
